import React from "react";
import { GalleryProps } from "./types";
import ContentSection from "./ContentSection";
import GalleryComponent from "../Gallery";
import cx from "classnames";

const Gallery: React.FC<GalleryProps> = ({
  data,
  heading,
  align,
  preview = false,
}) => {
  return (
    <ContentSection
      className={cx("my-5 w-full", `align-${align || "left"}`)}
      type={data.type}
      preview={preview}
    >
      {heading}
      <GalleryComponent {...data} />
    </ContentSection>
  );
};

export default Gallery;
